// 导入统一的枚举定义
import {OrderAddressType} from '../../../../../graphql/types/OrderDetailType';

// POD Review 列表类型定义
export interface PodReviewType {
    id: string;
    trackingNumber: string;
    channelOrderNumber?: string;
    podReviewStatus?: number;
    podStatusUpdatedAt?: string;
    firstPodUploadTime?: string;
    podReviewMessage?: string[];
    updatedAt?: string;
    client?: ChannelInfo;
    hub?: WarehouseInfo;
    whs?: WarehouseInfo;
    dsp?: DspInfo;
    driver?: AccountInfo;
    lastReviewer?: AccountInfo;
    reviewer?: AccountInfo;
    reviewTime?: string;
    podReviewNote?: string;
    orderId: number; // 订单ID
    area?: AreaInfo;
}

export interface ChannelInfo {
    id: string;
    channelName: string;
}

export interface WarehouseInfo {
    id: string;
    name: string;
    sortingCode?: string;
}

export interface DspInfo {
    id: string;
    name: string;
    dspCode?: string;
}

export interface AccountInfo {
    id: string;
    name: string;
    phone?: string;
}

export interface AreaInfo {
    id: string;
    name: string;
    sortingCode?: string;
}

// POD Review Tab状态枚举 - 用于前端Tab分类
export enum PodReviewTabType {
    NEWLY_FLAGGED = 1,
    DRIVER_RESUBMITTED = 2,
    AWAITING_DRIVER_UPDATE = 3,
    TERMINATED = 4
}

export interface PodReviewFilters {
    statusUpdatedAt?: TimeRange; // 状态更新时间范围
    podFirstUploadTime?: TimeRange; // POD首次上传时间范围
    // 按数据库字段精准匹配
    pickupHubIds?: string[]; // 选中的中心ID列表（仅前端使用）
    pickupHubSortingCodes?: string[]; // Hub的sorting_code列表（用于后端过滤）
    destWarehouseIds?: string[]; // 目的地仓库ID列表（精准匹配，支持多选）
    areaSortingCodeList?: string[]; // 区域的sorting_code列表（精准匹配，支持多选）
    deliveredDspIds?: string[]; // 配送DSP ID列表（精准匹配，支持多选）
    deliveredDriverAccountId?: string; // 配送司机账户ID（精准匹配）
    // 新增筛选字段
    podReviewStatus?: string; // POD审核状态
    trackingNumbers?: string; // 运单号
    channelOrderNumbers?: string; // 订单号（channel_order_number）
    reviewerId?: string; // 审核人ID（单选）
    failureReasons?: string[]; // 不合格原因列表（枚举值：NO_LABEL_PHOTO, WRONG_TRK, NO_HOUSE_APT, WRONG_HOUSE_APT, OTHER）
    reviewTime?: TimeRange; // 审核时间范围
}

export interface TimeRange {
    start: string;
    end: string;
}

export interface PodReviewAction {
    orderId: string;
    action: 'APPROVE' | 'DISAPPROVE' | 'SKIP';
    reasons?: string[];
    customComment?: string;
}

export interface PodReviewReason {
    code: string;
    label: string;
    description?: string;
}

// POD 图片，isRisky 标记该图是否命中内容风控
export interface PodImageType {
    s3Key: string;
    url: string;
    isRisky: boolean;
}

// POD Review 详情类型定义
export interface PodReviewDetailType {
    id: string;
    trackingNumber: string;
    podReviewStatus?: number;
    recipientAddress?: OrderAddressType;
    podReviewMessage?: string[];
    podReviewNote?: string;
    podImages: PodImageType[];
    lastReviewer?: AccountInfo;
    driver?: AccountInfo; // 配送司机
    firstPodUploadTime?: string; // 签收时间（POD首次上传时间）
    reviewTime?: string;
    orderId: string; // 订单ID
    deliveredLocation?: {
        latitude: number;
        longitude: number;
    };
    bFullAddress?: string | null; // 妥投时命中的B地址快照，未命中为null
    // 门牌免拍豁免标识（后端详情读路径实时查）：命中则该地址允许不拍门牌，仅辅助判断不代表自动通过
    podExemptHit?: boolean | null;
    podExemptTargetType?: string | null; // ADDRESS-单地址 / FENCE-围栏
    podExemptReasonCode?: string | null; // 豁免原因字典code
}


